import React from 'react';
import ProductCategoryDetailsFields from './ProductCategoryDetailsFields';

function ViewProductCategory({ CategoryData }) {
  return (
    <div className="card-body px-0">
      <ProductCategoryDetailsFields formData={CategoryData || {}} readOnly />
    </div>
  );
}

export default ViewProductCategory;
